import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import { PieChart } from "@mui/x-charts"
import { getUnloadingDurationReport } from "../../../features/reports/reportSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .title-list{
                display:grid;
                grid-template-columns: repeat(10, 1fr);
                width: 100%;
                gap: 20px;
                text-align: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
            }
            .main-side{
                text-align: center;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .info{
                    display:grid;
                    grid-template-columns: repeat(10, 1fr);
                    gap: 20px;
                    .text{
                        text-align: center;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
            .total-container{
                display:grid;
                grid-template-columns: repeat(10, 1fr);
                text-align: center;
                gap: 20px;
                width: 100%;
                margin-top: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                border-top: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-top: 10px;
                .total{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-md);
                }
            }
            .charts{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                margin-top: 30px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 20px;
        }
    }
`

const titles = ["Ay", "Tamamlanan Sefer Sayısı", "0-2", "2-4", "4-6", "6-8", "8-10", "10-12", "12-24", ">24"]

const BosaltmaSureleriModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()
    const { unloadingDurationReport } = useSelector(state => state.report)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const companyId = JSON.parse(storage.getItem("companyId"))    

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getUnloadingDurationReport(companyId))
    }, [companyId])

    const seriesData = [
        {
            data:  [
                { id: 1, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationZeroToTwoHours?.count, label: '0-2', color:"#E85446" },
                { id: 2, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationTwoToFourHours?.count, label: '2-4', color:"#F29E4C" },
                { id: 3, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationFourToSixHours?.count, label: '4-6', color:"#F1C40F" },
                { id: 4, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationSixToEightHours?.count, label: '6-8', color:"#2ECC71" },
                { id: 5, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationEightToTenHours?.count, label: '8-10', color:"#3498DB" },
                { id: 6, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationTenToTwelveHours?.count, label: '10-12', color:"#9B59B6" },
                { id: 7, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationTwelveToTwentyFourHours?.count, label: '12-24', color:"#34495E" },
                { id: 8, value: unloadingDurationReport?.yearlyUnloadingDuration?.durationOverTwentyFourHours?.count, label: '>24', color:"#16A085" },
            ]
        },
    ]

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"Boşaltma Süreleri Raporu"}/>
            <div className="content">
                
                <div className="title-list">
                    {titles.map((item) => (
                        <div className="title">{item}</div>
                    ))}
                </div>
                <div className="main-side">
                    {unloadingDurationReport?.monthlyUnloadingDurations?.$values?.map((item) => {
                        return (
                            <div className="info">
                                <div className="text">{item?.month}</div>
                                <div className="text">{item?.completedShipmentCount}</div>

                                <div className="text">{item?.unloadingDuration?.durationZeroToTwoHours?.count} ({parseInt(item?.unloadingDuration?.durationZeroToTwoHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationTwoToFourHours?.count} ({parseInt(item?.unloadingDuration?.durationTwoToFourHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationFourToSixHours?.count} ({parseInt(item?.unloadingDuration?.durationFourToSixHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationSixToEightHours?.count} ({parseInt(item?.unloadingDuration?.durationSixToEightHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationEightToTenHours?.count} ({parseInt(item?.unloadingDuration?.durationEightToTenHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationTenToTwelveHours?.count} ({parseInt(item?.unloadingDuration?.durationTenToTwelveHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationTwelveToTwentyFourHours?.count} ({parseInt(item?.unloadingDuration?.durationTwelveToTwentyFourHours?.rate)}%)</div>
                                <div className="text">{item?.unloadingDuration?.durationOverTwentyFourHours?.count} ({parseInt(item?.unloadingDuration?.durationOverTwentyFourHours?.rate)}%)</div>
                            </div>
                        )
                    })}
                    
                </div>
                <div className="total-container">
                    <div className="total">Toplam</div>
                    <div className="calc">{unloadingDurationReport?.yearlyCompletedShipmentCount}</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationZeroToTwoHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationZeroToTwoHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationTwoToFourHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationTwoToFourHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationFourToSixHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationFourToSixHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationSixToEightHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationSixToEightHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationEightToTenHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationEightToTenHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationTenToTwelveHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationTenToTwelveHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationTwelveToTwentyFourHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationTwelveToTwentyFourHours?.rate)}%)</div>
                    <div className="calc">{unloadingDurationReport?.yearlyUnloadingDuration?.durationOverTwentyFourHours?.count} ({parseInt(unloadingDurationReport?.yearlyUnloadingDuration?.durationOverTwentyFourHours?.rate)}%)</div>
                </div>
                <div className="charts">
                    <PieChart
                        series={seriesData}
                        width={600}
                        height={200}
                    />
                </div>
            </div>
            <div className='button-grp'>
                <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </ModalContainer>
  )
}

export default BosaltmaSureleriModal